import { render, staticRenderFns } from "./follow-records.vue?vue&type=template&id=1ad731f2&scoped=true"
import script from "./follow-records.vue?vue&type=script&lang=js"
export * from "./follow-records.vue?vue&type=script&lang=js"
import style0 from "./follow-records.vue?vue&type=style&index=0&id=1ad731f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad731f2",
  null
  
)

export default component.exports